import { emitSocketV2ResearchAssistantEvent } from '@verantos-dev/app-state-base';
import { COHORT_ACTIONS, ModelVersion } from '@verantos-dev/app-state-research-assistant';
import { transformUser } from '@verantos-dev/core-auth';
import { IVerantosUser } from '@verantos-dev/types-common';

type EmitUserPromptLegacyProps = {
  userPrompt: string;
  model: ModelVersion;
  cohortVersionId: string;
  cohortId: string;
  projectId: string;
  user: IVerantosUser;
  callback?: (data?: number) => void;
};

type EmitUserSaveEvent = {
  model: ModelVersion;
  cohortVersionId: string;
  cohortId: string;
  projectId: string;
  user: IVerantosUser;
  cohortAction: COHORT_ACTIONS;
};

export const emitUserPromptLegacy = ({
  userPrompt,
  cohortId,
  model,
  projectId,
  cohortVersionId,
  user,
}: EmitUserPromptLegacyProps) => {
  emitSocketV2ResearchAssistantEvent('publish', {
    message: userPrompt,
    model,
    data: {
      cohortVersionId,
      cohortId,
      projectId,
      userInfo: transformUser(user),
    },
  });
};

export const emitUserSaveEvent = ({
  cohortId,
  model,
  projectId,
  cohortVersionId,
  user,
  cohortAction,
}: EmitUserSaveEvent) => {
  emitSocketV2ResearchAssistantEvent('save', {
    model,
    data: {
      cohortVersionId,
      cohortId,
      projectId,
      userInfo: transformUser(user),
      cohortAction,
    },
  });
};

export const emitGenerateSummaryMessage = (
  projectId: string,
  cohortId: string,
  model: ModelVersion
) => {
  emitSocketV2ResearchAssistantEvent('generateSummary', {
    message: 'generateSummary',
    studyId: projectId,
    cohortId,
    model,
  });
};
